import React from 'react';
import { useIntl } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CreateDriverWizardContainer } from '../containers/create-driver-wizard-container/create-driver-wizard-container';
import { DriverBuilderContextProvider } from '../contexts/driver-builder-context/driver-builder-context';
import { useSidebarResetCounter } from '../../hooks/useSidebarResetCounter/useSidebarResetCounter';

export interface DriverBuilderSidebarData {
  driverId?: string;
}

interface DriverBuilderSidebarProps {
  data?: DriverBuilderSidebarData;
  isOpen: boolean;
  onClose: () => void;
}

export const DriverBuilderSidebar = ({ isOpen, onClose, data }: DriverBuilderSidebarProps) => {
  const intl = useIntl();
  const { resetKey, handleReset, hasReset } = useSidebarResetCounter(isOpen);
  const driverId = hasReset ? undefined : data?.driverId; // Only use driverId from props on first run (if we haven't reset yet

  return (
    <Sidebar
      open={isOpen}
      onCancel={onClose}
      header={
        <Typography variant="h2" fontWeight="700">
          {driverId
            ? intl.formatMessage({ id: 'predict.edit_non_financial_driver', defaultMessage: 'Edit non-financial driver' })
            : intl.formatMessage({ id: 'predict.create_non_financial_driver', defaultMessage: 'Create non-financial driver' })}
        </Typography>
      }
      width="85%"
    >
      <DriverBuilderContextProvider key={resetKey} driverId={driverId}>
        <CreateDriverWizardContainer onClose={onClose} onReset={handleReset} />
      </DriverBuilderContextProvider>
    </Sidebar>
  );
};
